// RGM Submit Music genres — single source for Submit Music and Studio.
export const SUBMIT_MUSIC_GENRES = [
  "Hip Hop",
  "Rap",
  "Trap",
  "R&B",
  "Pop",
  "Afrobeats",
  "Dancehall",
  "Reggae",
  "Drill",
  "Alternative",
  "Other",
];
